export { default } from './AvatarGroup';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/AvatarGroup/index.js
// module id = 883
// module chunks = 2